export default {
  'standard-residential': {
    name: 'Standard Residential Property',
    description: 'Template for typical residential gas safety inspection',
    data: {
      appliances: [
        {
          type: 'Boiler',
          location: 'Kitchen',
          make: '',
          flueType: 'Room Sealed',
          safetyCheck: '',
          remedialAction: ''
        },
        {
          type: 'Cooker',
          location: 'Kitchen',
          make: '',
          flueType: 'N/A',
          safetyCheck: '',
          remedialAction: ''
        }
      ]
    }
  },
  'commercial-property': {
    name: 'Commercial Property',
    description: 'Template for commercial property gas safety inspection',
    data: {
      appliances: [
        {
          type: 'Boiler',
          location: 'Plant Room',
          make: '',
          flueType: 'Open Flue',
          safetyCheck: '',
          remedialAction: ''
        }
      ]
    }
  }
};